import { render, staticRenderFns } from "./Undo.vue?vue&type=template&id=8f7790ea&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Undo.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/Undo.vue
// module id = 2443
// module chunks = 1